import React from 'react'
import styled, { keyframes } from 'styled-components'
import { highestZIndex } from 'shared/css/z-indexes'

const slideIn = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(82px);
    }
`
const InnerContainer = styled.div`
    text-align: left;
    width: 1040px;
    min-width: 1040px;
    color: #fff;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0.21px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
        font-weight: bold;
    }
`

const Banner = styled.div`
    width: 100%;
    position: absolute;
    top: -82px;
    left: 0;
    height: 82px;
    background: linear-gradient(-135deg, rgb(255, 102, 102) 0%, rgb(97, 87, 255) 100%);
    z-index: ${highestZIndex};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: 0.3s ${slideIn} ease-out;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
`

const Emoji = styled.span`
    position: relative;
    font-size: 28px;
    margin-right: 19px;
`

const LeftContent = styled.div`
    display: flex;
    align-items: center;
`

const PromoContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 47px;
    justify-content: space-between;
`

const slideInForCTA = `(max-width: 1100px)`
const RightContent = styled.div`
    font-size: 16px;
    @media ${slideInForCTA} {
        transform: translateX(-70px);
        transition: transform 300ms ease-out;
    }
`

const RightArrow = styled.div`
    display: inline;
    position: relative;
    top: 3px;
    margin-left: 10px;
`

const PromoTitle = styled.span`
    font-size: 20px;
    font-weight: 900;
`

const PromoBody = styled.span`
    font-size: 15px;
`
type TwoLineBannerProps = {
    title: string
    description: string
    linkLabel?: string
    linkDestination?: string
}

const TwoLineBanner = ({ title, description, linkLabel, linkDestination }: TwoLineBannerProps) => {
    return (
        <Banner>
            <InnerContainer>
                <LeftContent>
                    <Emoji>👋</Emoji>
                    <PromoContainer>
                        <PromoTitle>{title}</PromoTitle>
                        <PromoBody>{description}</PromoBody>
                    </PromoContainer>
                </LeftContent>
                <RightContent>
                    {linkDestination && linkLabel && (
                        <>
                            <a href={linkDestination}>{linkLabel}</a>
                            <RightArrow className="ss-icon ss-navigateright" />
                        </>
                    )}
                </RightContent>
            </InnerContainer>
        </Banner>
    )
}

export default TwoLineBanner
